import React from 'react'
import { useSelector } from 'react-redux'

import BaseEntity from 'app/components/BaseEntity'
import constants from 'app/constants'
import { enrolmentColumns } from 'app/pages/Orders/columns/activeCare'
import { fetchActiveCareLinksData } from 'app/store/actions/ordersEntity'

// Children enrolled in an Active Care batch from a paid Booking link. Kept
// apart from School & Care, which lists admissions.
const ActiveCareEnrolment = () => {
  const data = useSelector(
    (state) => state.ordersEntityReducer.activeCareEnrolmentsData
  )
  const columns = React.useMemo(
    () => enrolmentColumns(() => data?.data),
    [data]
  )

  return (
    <BaseEntity
      entity={constants.ACTIVE_CARE_ENROLMENTS}
      label={constants.ACTIVE_CARE_ENROLMENTS_LABEL}
      fetchData={fetchActiveCareLinksData}
      data={data}
      columns={columns}
      readOnly
    />
  )
}

export default ActiveCareEnrolment
